import React from 'react';
import {
    startOfMonth,
    endOfMonth,
    startOfWeek,
    endOfWeek,
    addDays
} from 'date-fns';
import { Locale } from 'date-fns/locale';
import DayCell from './DayCell';
import { findEvent } from './utils';

interface CalendarGridProps {
    currentMonth: Date;
    minDate: Date;
    maxDate: Date;
    disabledDays: Date[];
    localSelectedDate: Date;
    rangeStart: Date | null;
    rangeEnd: Date | null;
    hoverDate: Date | null;
    eventsByDate: Map<string, Event>;
    onDateClick: (day: Date) => void;
    onMouseEnter: (day: Date) => void;
    onMouseLeave: () => void;
    locale: Locale;
}

const CalendarGrid: React.FC<CalendarGridProps> = ({
    currentMonth,
    minDate,
    maxDate,
    disabledDays,
    localSelectedDate,
    rangeStart,
    rangeEnd,
    hoverDate,
    eventsByDate,
    onDateClick,
    onMouseEnter,
    onMouseLeave,
    locale
}) => {
    // Calculate dates for the calendar grid
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startWeek = startOfWeek(monthStart);
    const endWeek = endOfWeek(monthEnd);

    const rows = [];
    let days = [];
    let day = startWeek;

    // Build the calendar grid
    while (day <= endWeek) {
        for (let i = 0; i < 7; i++) {
            const cloneDay = day;
            const event = findEvent(day, eventsByDate);

            days.push(
                <DayCell
                    key={day.toString()}
                    day={cloneDay}
                    monthStart={monthStart}
                    minDate={minDate}
                    maxDate={maxDate}
                    disabledDays={disabledDays}
                    localSelectedDate={localSelectedDate}
                    rangeStart={rangeStart}
                    rangeEnd={rangeEnd}
                    hoverDate={hoverDate}
                    event={event}
                    onDateClick={onDateClick}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    locale={locale}
                />
            );
            day = addDays(day, 1);
        }

        rows.push(
            <div key={day.toString()} className="grid grid-cols-7 gap-1">
                {days}
            </div>
        );
        days = [];
    }

    return <div className="space-y-1 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100">{rows}</div>;
};

export default React.memo(CalendarGrid);